import logoSm from "../assets/images/logo-sm.png";
import logoDarkBr from "../assets/images/logo-dark.png";
import logoLightBr from "../assets/images/logo-light.png";
import logoDarkSend from "../assets/images/logo-brsend-dark.png";
import logoLightSend from "../assets/images/logo-brsend-light.png";

/**
 * Porta internacional brsend.com = mesmo app, marca/locale default diferentes (DOC 20 § 4.3).
 * Por quê: um build; o Host decide wordmark e idioma inicial — sem dois softwares.
 * Wordmark intl = PNG (SVG gerado quebrava no browser).
 */
export function isIntlPortalHost(
  hostname: string = typeof window !== "undefined" ? window.location.hostname : ""
): boolean {
  return /(^|\.)brsend\.com$/i.test(hostname);
}

export function getBrandName(): string {
  return isIntlPortalHost() ? "Br Send" : "Br Envio";
}

export type BrandLogos = {
  sm: string;
  dark: string;
  light: string;
  alt: string;
};

export function getBrandLogos(): BrandLogos {
  if (isIntlPortalHost()) {
    return {
      sm: logoSm,
      dark: logoDarkSend,
      light: logoLightSend,
      alt: "Br Send",
    };
  }
  return {
    sm: logoSm,
    dark: logoDarkBr,
    light: logoLightBr,
    alt: "Br Envio",
  };
}

/** Locale inicial quando ainda não há I18N_LANGUAGE no localStorage. */
export function defaultLocaleForHost(): "en" | "pt-BR" {
  return isIntlPortalHost() ? "en" : "pt-BR";
}
